import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UploadFileService } from "../../services/uploadfile.service";
import { DsFile } from "../../models/ds-file.model";
import { logger } from "../../utils/logger";
import { ApiPage } from "../../models/api-page.model";
import { templateModel } from "../../models/template.model";

const log = logger.getLogger("FileErrors");
export interface ListOfficeRequestsType {
  page: number;
  sortType: string;
  size: number;
  searchTerm: string;
}
interface TemplateListRequest {
  officeId?: string;
  searchTerm?: string;
  page: number;
  size: number;
  sortType: string;
}
interface InitialStateType {
  loading: boolean;
  error: boolean;
  success: boolean;
  templateList: ApiPage<templateModel> | null;
  sort: {
    start: number;
    end: number;
    pageNumber: number;
    rowsPerPage: number;
    sortedBy: string;
  };
}

const initialState: InitialStateType = {
  loading: false,
  error: false,
  success: false,
  templateList: null,
  sort: {
    start: 0,
    end: 10,
    pageNumber: 0,
    rowsPerPage: 10,
    sortedBy: "templateName,asc",
  },
};

interface UpdateRequest {
  templateName: string;
  templateContent: string;
}

export const uploadCommonFile = createAsyncThunk(
  "file/upload",
  async ({ file, callback = () => {} }: { file: File; callback?: (progress: number) => void }, { rejectWithValue }) => {
    try {
      const res = await UploadFileService.uploadFile(file, callback);
      return res as DsFile;
    } catch (err) {
      log.warn(JSON.stringify(err));
      return rejectWithValue(err);
    }
  }
);
// listOfficeRequestsEmail
export const getAllTemplateData = createAsyncThunk(
  "emailTemplate/list",
  async ({ page, sortType, size, searchTerm = "" }: TemplateListRequest, { rejectWithValue }) => {
    try {
      const res = await UploadFileService.getTemplateList(searchTerm, page, size, sortType);
      return { data: res, sortType: sortType, page, size };
    } catch (e) {
      log.warn(JSON.stringify(e));
      return rejectWithValue(null);
    }
  }
);
export const templateDeleteByTemplateName = createAsyncThunk("delete/template", async ({ formId }: { formId: string }, { rejectWithValue }) => {
  try {
    const response = await UploadFileService.deleteTemplate(formId);
    return response;
  } catch (e) {
    log.warn(JSON.stringify(e));
    return false;
  }
});
export const getDataFromtemplateName = createAsyncThunk(
  "templateData/bytemplateName",
  async ({ templateName }: { templateName: string }, { rejectWithValue }) => {
    try {
      const res = await UploadFileService.templateDataBytemplateName(templateName);
      return { data: res };
    } catch (e) {
      log.warn(JSON.stringify(e));
      return rejectWithValue(null);
    }
  }
);
export const addRequest = createAsyncThunk("add/Template", async ({ request }: { request: UpdateRequest }, { rejectWithValue }) => {
  try {
    const response = await UploadFileService.addsingleTemplate(request);
    return response;
  } catch (error) {
    log.warn(JSON.stringify(error));
    return rejectWithValue(error);
  }
});
export const updateRequest = createAsyncThunk("update/Template", async ({ request }: { request: UpdateRequest }, { rejectWithValue }) => {
  try {
    const response = await UploadFileService.updateSingleTemplate(request);
    return response;
  } catch (error) {
    log.warn(JSON.stringify(error));
    return rejectWithValue(error);
  }
});

export const EmailTemplateSlice = createSlice({
  name: "fileApi",
  initialState,
  reducers: {
    resetEmailTemplateState: () => initialState,
    clearTemplateList: state => {
      state.templateList = null;
    },
    resetTemplateTableSort: state => {
      state.sort = {
        start: 0,
        end: 10,
        pageNumber: 0,
        rowsPerPage: 10,
        sortedBy: "templateName,asc",
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllTemplateData.fulfilled, (state, action) => {
      state.error = false;
      state.loading = false;
      state.templateList = action.payload.data as ApiPage<templateModel>;
      state.sort.pageNumber = action.payload.page;
      state.sort.rowsPerPage = action.payload.size;
      state.sort.sortedBy = action.payload.sortType;
    });
  },
});

export default EmailTemplateSlice.reducer;
